import LiveEvent from './live-event'
import LiveEventPageQuery from './live-event.query'

export { LiveEventPageQuery }

export default LiveEvent
